var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discord"},[_c('p',{on:{"click":function($event){return _vm.jumpDiscord()}}},[_vm._v("Discord")])])}
var staticRenderFns = []

export { render, staticRenderFns }